
const initialState = {tourSliderValue : 30, mapSliderValue: 90, syncViews : false, map: true, infoDialog: true, tours: [], tourName: ""}

export default function tourReducer(state = initialState, action){
    switch(action.type){
        case 'update/upperWindow' : {
            return {
                    ...state,
                    upperWindow : action.tour,
                    belowWindow : state.belowWindow,
                    tourSliderValue : state.tourSliderValue,
                    mapSliderValue: state.mapSliderValue,
                    syncViews : state.syncViews,
                    map : state.map,
                    infoDialog: state.infoDialog,
                    tours: state.tours,
                    tourName: state.tourName,   
                }
            
        }
        case 'update/belowWindow' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : action.tour,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : state.syncViews, 
                map : state.map,
                infoDialog: state.infoDialog,
                tours: state.tours,
                tourName: state.tourName, 
            }
        }
        case 'update/tourSlider' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : action.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : state.syncViews,
                map : state.map, 
                infoDialog: state.infoDialog,
                tours: state.tours,
                tourName: state.tourName, 
            }
        }
        case 'update/mapSlider' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: action.mapSliderValue,
                syncViews : state.syncViews,
                map : state.map,
                infoDialog: state.infoDialog,
                tours: state.tours,
                tourName: state.tourName,  
            }
        }
        case 'update/syncViews' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : !state.syncViews,
                map : state.map,
                infoDialog: state.infoDialog,
                tours: state.tours,
                tourName: state.tourName, 
            }
        }
        case 'openclose/map' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : state.syncViews,
                map : !state.map,
                infoDialog: state.infoDialog,
                tours: state.tours,
                tourName: state.tourName, 
            }
        }
        case 'update/infoDialog' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : state.syncViews,
                map : state.map,
                infoDialog: action.infoDialog,
                tours: state.tours,
                tourName: state.tourName, 
            }
        }
        case 'update/tours' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : state.syncViews,
                map : state.map,
                infoDialog: state.infoDialog, 
                tours: action.tours,
                tourName: state.tourName,
            }
        }
        case 'update/tourName' : {
            return {
                ...state,
                upperWindow : state.upperWindow,
                belowWindow : state.belowWindow,
                tourSliderValue : state.tourSliderValue,
                mapSliderValue: state.mapSliderValue,
                syncViews : state.syncViews,
                map : state.map,
                infoDialog: state.infoDialog, 
                tours: state.tours,
                tourName: action.tourName,
            }
        }
        default :
            return state;
    }
}